module.exports = __webpack_public_path__ + "static/media/logotype.d5e16997.svg";